<template>
  <div class="page-editor">
    <CRow>
      <CCol col="12" xl="12">
        <CCard class="pr-0">
          <CCardBody>
            <a-card class="edit-card" style="margin:0;" :body-style="{padding:0}">
              <span slot="title">
                <h6 class="w-100 mb-0 text-muted">Nástroje</h6>
                Bonus Log
              </span>

              <!-- Filtre -->
              <div class="p-3 pb-0">
                <div class="d-flex flex-wrap align-items-end" style="gap:10px;">
                  <div>
                    <label class="filter-label">Objednávka</label>
                    <a-input v-model="filters.order_id" placeholder="Číslo obj." size="small" style="width:140px;" @pressEnter="fetchLogs" />
                  </div>
                  <div>
                    <label class="filter-label">Zdroj</label>
                    <a-select v-model="filters.source" placeholder="Všetky" size="small" style="width:140px;" allowClear>
                      <a-select-option value="cardpay">cardpay</a-select-option>
                      <a-select-option value="tatrapayplus">tatrapayplus</a-select-option>
                      <a-select-option value="basket">basket</a-select-option>
                      <a-select-option value="manual">manual</a-select-option>
                    </a-select>
                  </div>
                  <div>
                    <label class="filter-label">Endpoint</label>
                    <a-select v-model="filters.endpoint" placeholder="Všetky" size="small" style="width:220px;" allowClear show-search>
                      <a-select-option value="UlozDoklad">UlozDoklad</a-select-option>
                      <a-select-option value="UlozPolozkuDokladu">UlozPolozkuDokladu</a-select-option>
                      <a-select-option value="UlozUhraduDokladu">UlozUhraduDokladu</a-select-option>
                      <a-select-option value="UlozFirmu">UlozFirmu</a-select-option>
                      <a-select-option value="UlozOsobu">UlozOsobu</a-select-option>
                      <a-select-option value="UlozOsobuFirmy">UlozOsobuFirmy</a-select-option>
                      <a-select-option value="VratVlastnostiTypy">VratVlastnostiTypy</a-select-option>
                      <a-select-option value="VratSortiment">VratSortiment</a-select-option>
                      <a-select-option value="VratSkupiny">VratSkupiny</a-select-option>
                      <a-select-option value="VratDoklad">VratDoklad</a-select-option>
                      <a-select-option value="VratFirmu">VratFirmu</a-select-option>
                      <a-select-option value="VratOsobu">VratOsobu</a-select-option>
                      <a-select-option value="VratStavKonta">VratStavKonta</a-select-option>
                      <a-select-option value="VratZoznamDokladov">VratZoznamDokladov</a-select-option>
                    </a-select>
                  </div>
                  <div>
                    <label class="filter-label">Od</label>
                    <a-date-picker v-model="filters.date_from" size="small" format="DD.MM.YYYY" valueFormat="YYYY-MM-DD" />
                  </div>
                  <div>
                    <label class="filter-label">Do</label>
                    <a-date-picker v-model="filters.date_to" size="small" format="DD.MM.YYYY" valueFormat="YYYY-MM-DD" />
                  </div>
                  <a-button type="primary" size="small" @click="fetchLogs">Filtrovať</a-button>
                </div>
              </div>

              <!-- Tabuľka -->
              <div class="p-3">
                <a-spin v-if="loading" class="d-block text-center p-4" />
                <template v-else>
                  <table class="bislog-table w-100" v-if="logs.length">
                    <thead>
                      <tr>
                        <th>Čas</th>
                        <th>Objednávka</th>
                        <th>Endpoint</th>
                        <th>Zdroj</th>
                        <th>HTTP</th>
                        <th>Trvanie</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="log in logs" :key="log.id" :class="{'bislog-error': log.http_code >= 400}">
                        <td class="text-nowrap">{{ formatDate(log.created) }}</td>
                        <td>
                          <router-link v-if="log.order_id" :to="'/order/' + log.order_id">{{ log.order_id }}</router-link>
                          <span v-else class="text-muted">—</span>
                        </td>
                        <td><a-tag>{{ log.endpoint }}</a-tag></td>
                        <td><span class="bislog-source">{{ log.source || '—' }}</span></td>
                        <td>
                          <a-tag :color="log.http_code >= 400 ? 'red' : log.http_code >= 200 ? 'green' : 'default'">{{ log.http_code }}</a-tag>
                        </td>
                        <td class="text-muted">{{ log.duration_ms }}ms</td>
                        <td class="text-right">
                          <a-button size="small" @click="showDetail(log)"><i class="fas fa-eye"></i></a-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-else class="text-center text-muted p-4">Žiadne záznamy</div>

                  <!-- Stránkovanie -->
                  <div class="text-center mt-3" v-if="totalPages > 1">
                    <a-pagination size="small" :current="currentPage" :total="total" :pageSize="limit" @change="onPageChange" />
                  </div>
                </template>
              </div>
            </a-card>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <!-- Detail modal -->
    <a-modal v-model="detailVisible" title="Detail logu" width="800px" :footer="null">
      <template v-if="detailLog">
        <div class="bislog-detail-meta mb-3">
          <a-row :gutter="16">
            <a-col :span="8"><strong>Endpoint:</strong> {{ detailLog.endpoint }}</a-col>
            <a-col :span="8"><strong>Metóda:</strong> {{ detailLog.method }}</a-col>
            <a-col :span="8"><strong>HTTP:</strong> <a-tag :color="detailLog.http_code >= 400 ? 'red' : 'green'">{{ detailLog.http_code }}</a-tag></a-col>
          </a-row>
          <a-row :gutter="16" class="mt-2">
            <a-col :span="8"><strong>Objednávka:</strong> {{ detailLog.order_id || '—' }}</a-col>
            <a-col :span="8"><strong>Zdroj:</strong> {{ detailLog.source || '—' }}</a-col>
            <a-col :span="8"><strong>Trvanie:</strong> {{ detailLog.duration_ms }}ms</a-col>
          </a-row>
        </div>
        <a-divider />
        <h6 class="mb-2">Request</h6>
        <pre class="bislog-json">{{ prettyJson(detailLog.request_data) }}</pre>
        <h6 class="mb-2 mt-3">Response</h6>
        <pre class="bislog-json">{{ prettyJson(detailLog.response_data) }}</pre>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { dataService } from '../_services'
import moment from 'moment'

export default {
  name: 'bislog',
  data() {
    return {
      logs: [],
      loading: false,
      total: 0,
      currentPage: 1,
      limit: 50,
      filters: { order_id: '', source: undefined, endpoint: undefined, date_from: null, date_to: null },
      detailVisible: false,
      detailLog: null,
    }
  },
  computed: {
    totalPages() { return Math.ceil(this.total / this.limit) }
  },
  mounted() { this.fetchLogs() },
  methods: {
    fetchLogs() {
      this.loading = true
      let params = '?page=' + this.currentPage + '&limit=' + this.limit
      if (this.filters.order_id) params += '&order_id=' + this.filters.order_id
      if (this.filters.source) params += '&source=' + this.filters.source
      if (this.filters.endpoint) params += '&endpoint=' + this.filters.endpoint
      if (this.filters.date_from) params += '&date_from=' + this.filters.date_from
      if (this.filters.date_to) params += '&date_to=' + this.filters.date_to

      dataService.axiosFetch('bislog' + params).then(results => {
        if (results) {
          this.logs = results.results || []
          this.total = results.total || 0
        }
      }).finally(() => { this.loading = false })
    },
    onPageChange(page) {
      this.currentPage = page
      this.fetchLogs()
    },
    showDetail(log) {
      this.detailLog = log
      this.detailVisible = true
    },
    formatDate(d) { return d ? moment(d).format('D.M.YYYY HH:mm') : '—' },
    prettyJson(str) {
      if (!str) return '—'
      try { return JSON.stringify(JSON.parse(str), null, 2) }
      catch(e) { return str }
    }
  }
}
</script>

<style scoped>
.filter-label { display: block; font-size: 11px; font-weight: 500; color: #64748b; margin-bottom: 2px; }
.bislog-table { border-collapse: collapse; font-size: 13px; }
.bislog-table th { padding: 8px 12px; font-size: 11px; font-weight: 600; color: #94a3b8; text-transform: uppercase; letter-spacing: .04em; border-bottom: 1px solid #e2e8f0; white-space: nowrap; }
.bislog-table td { padding: 8px 12px; border-bottom: 1px solid #f8fafc; vertical-align: middle; }
.bislog-table tr:hover td { background: #f8fafc; }
.bislog-error td { background: #fef2f2; }
.bislog-source { font-size: 12px; color: #64748b; }
.bislog-json { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 4px; padding: 12px; font-size: 12px; max-height: 300px; overflow-y: auto; white-space: pre-wrap; word-break: break-all; }
.bislog-detail-meta { font-size: 13px; }
</style>
